import { render } from "./Landing3.vue?vue&type=template&id=62f4099d"
import script from "./Landing3.vue?vue&type=script&lang=js"
export * from "./Landing3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__